export const EVENT_CATEGORY = "login";
export const EVENT_ACTION = {
  LOGIN: "login-module",
};
